import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Constants } from './common/constants';


export interface Speaker {
  id: number;
  name: string;
  bio: string;
  imageUrl: string; 
  company: string;
  address: string;
  phoneNumber: string;
  email: string;
  
}
export interface Meetup {
  amount: any;
  meetUpGalleryImages: any;
  id: number; // Primary key
  name: string;
  startDate:Date;
  endDate:Date;
  topic: string;
  venue: string;
  organizerName: string;
  createdAt:Date;
  selectedSpeakers: Speaker[];
  bannerImage:string;
  editorContent: string,
  meetupType:boolean,
  isExternal:boolean;
  isPayment:boolean;
  totalAmount:number;
}

export interface testimonial{
  id:number;
  name:string;

  companyName:string;
  designation:string;
  imageUrl:string;
  comment:string;
}

export interface EventTestimonial {
  id:number;
  name: string;
  designation: string;
  comment: string;

}

@Injectable({
  providedIn: 'root'
})
export class MiteventsService {
  baseUrl=Constants.baseUrl;
  private apiUrl=this.baseUrl+'/api/MeetUp';

  baseUrltestimonial = Constants.baseUrl + '/api/Testimonial';
  eventtestimonialbaseUrl =Constants.baseUrl+'/EventTestimonials';
  constructor(private http: HttpClient) {}
  
  getAllMeetups(): Observable<Meetup[]> {
    return this.http.get<Meetup[]>(`${this.apiUrl}/AllMitevents`);
  }
  
  registerToEvent(inputdata:any){
    return this.http.post(this.apiUrl+'/',inputdata)
  }
  getMeetupById(id: number): Observable<Meetup> {
    return this.http.get<Meetup>(`${this.apiUrl}/mitevent/${id}`);
  }

  SendContactDetails(contactData:any){
    return this.http.post(this.baseUrl+'/api/Form/sendContactemail',contactData,{responseType: 'text'})
  }
  SendSubscriberDetails(subscribeData:any){
    return this.http.post(this.baseUrl+'/api/Form/subcriberDetails',subscribeData,{responseType: 'text'})
  }
  SendEbookDetails(ebookData:any){
    return this.http.post(this.baseUrl+'/api/Form/ebookDetails',ebookData,)
  }

  // Fetch all testimonials
  getTestimonials(): Observable<testimonial[]> {
    return this.http.get<testimonial[]>(`${this.baseUrltestimonial}/GetAllTestimonial`);
  }

 
  getTestimonialsByMeetUpId(meetUpId: number): Observable<EventTestimonial[]> {

    return this.http.get<EventTestimonial[]>(`${this.baseUrl}/api/EventTestimonials/get-by-meetup/${meetUpId}`, );
  }
  checkEnrollmentStatus(eventId: number, email: string): Observable<{ isRegistered: boolean; message: string }> {
    return this.http.get<{ isRegistered: boolean; message: string }>(
      this.baseUrl+`/api/Enrollment/enrollmentStatus/${eventId}/${email}`
    );}

}

